import { render, staticRenderFns } from "./MovieTicketSelection.vue?vue&type=template&id=70a8b565&"
import script from "./MovieTicketSelection.vue?vue&type=script&lang=js&"
export * from "./MovieTicketSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports